import React, {Component} from "react"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"

import padding from "@irati/ui/src/global/padding"
import ErrorText from "@irati/ui/src/ErrorText"
import Error from "@irati/ui/src/Loading/Error"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {InjectIntl, injectIntl, FormattedMessage} from "@irati/utils/lang"

const MobileValidationButton = styled(ValidationButton)`
  margin-bottom: ${padding.tiny};
`

const StyledError = styled.div`
  margin-bottom: ${padding.tiny};
`

interface Props extends InjectIntl {
  onNext: () => void
  apolloState: ApolloState
  trophyValidationError: boolean
  nextText?: string | null
  id?: string | null
}

interface State {
  apolloState: ApolloState
}

class CTA extends Component<Props, State> {
  static defaultProps: Pick<Props, "nextText" | "id"> = {
    nextText: null,
    id: null
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      apolloState: props.apolloState
    }
  }

  /* The getDerivedStateFromProps below is a temporary hack that only returns unmodified apolloState if the previous
  apolloState was loading. Otherwise it overrides apolloState.error to null. This means any time the user updates a
  form field the error will be hidden. It should be the responsibility of react-apollo to reset error to null on
  rerender/ when props are changed and is a common issue that other people are experiencing ie:
    https://github.com/apollographql/react-apollo/issues/2191
  We shall keep our eye on react-apollo and when it's fixed on there end, we can update our package and remove the
  function below. */

  static getDerivedStateFromProps(props: Props, prevState: State) {
    const {apolloState} = props
    if (prevState.apolloState.loading) {
      return {apolloState}
    }
    return {apolloState: {...apolloState, error: null}}
  }

  render() {
    const {onNext, nextText, id, trophyValidationError, formatMessage} = this.props
    const {apolloState} = this.state

    const INVALID_ARGS_ERROR_CODE = "PBRECInvalidArguments"

    return (
      <Row>
        {apolloState.error && (
          <Col xs={12}>
            <StyledError>
              {apolloState.errorMsg!.includes(INVALID_ARGS_ERROR_CODE) && trophyValidationError ? (
                <ErrorText>{formatMessage({id: "recognition.popup.shared.cta.noTrophySelected.message"})}</ErrorText>
              ) : (
                <Error errorMsg={apolloState.errorMsg} />
              )}
            </StyledError>
          </Col>
        )}
        <Col xs={12} smHidden mdHidden lgHidden>
          <MobileValidationButton id={id} apolloState={apolloState} onClick={onNext} primary large full>
            {nextText || <FormattedMessage id="recognition.popup.shared.cta.launch" />}
          </MobileValidationButton>
        </Col>
        <Col xsHidden sm={12}>
          <ValidationButton id={id} onClick={onNext} apolloState={apolloState} primary large full>
            {nextText || <FormattedMessage id="recognition.popup.shared.cta.launch" />}
          </ValidationButton>
        </Col>
      </Row>
    )
  }
}

export default injectIntl(CTA)
